import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Pre-flight a save: may this user store `count` more items of this type?
 *
 * Mirrors the `/can_user_save` pattern used before saving a scenario — ask
 * first so the UI can explain and offer an upgrade, rather than letting the
 * user fill in a form and meet a 403.
 *
 * @param {'location'|'vehicle'|'vehicle_type'} itemType
 * @param {number} count
 * @returns {Promise<{allowed: boolean, remaining: number|null, limit: number|null, tier: string}>}
 */
async function can_user_save_items(itemType, count) {
  return generic_backend_request_post(
    { item_type: itemType, count }, '/can_user_save_items');
}

export default can_user_save_items;
